import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Es muy caro?',
  answer: 'Por $150 tienes una herramienta que trabaja para ti 365 días al año. Un solo cliente nuevo la paga.'
}, {
  question: '¿No me alcanza con Instagram?',
  answer: 'Instagram depende del algoritmo y no proyecta el mismo nivel de profesionalismo. Una web te hace dueño de tu presencia digital.'
}, {
  question: 'No sé nada de tecnología',
  answer: 'No necesitas saber nada. Nosotros hacemos todo. Tú solo apruebas el resultado.'
}, {
  question: '¿Cuánto tiempo tarda?',
  answer: 'Trabajamos rápido. Contáctanos y te decimos el tiempo exacto según tu proyecto. En un máximo de 7 días hábiles desde que confirmamos el pago y recibes el cuestionario inicial. Muchos proyectos se entregan antes.'
}, {
  question: '¿Y si no me gusta el diseño?',
  answer: 'Trabajamos contigo hasta que estés 100% satisfecho con tu página.'
}, {
  question: '¿Es seguro contratar online?',
  answer: 'Krove Latam tiene contacto directo por WhatsApp y correo. Hablamos contigo en cada paso del proceso.'
}, {
  question: '¿Qué pasa después del lanzamiento?',
  answer: 'Puedes contratar nuestro plan de mantenimiento por $20/mes e incluye actualizaciones de contenido, soporte técnico y copias de seguridad mensuales.'
}, {
  question: '¿La web aparecerá en Google?',
  answer: 'Incluimos configuración básica de SEO local. Para resultados más avanzados, ofrecemos servicios adicionales de posicionamiento.'
}, {
  question: '¿Puedo hacer cambios después de que esté lista?',
  answer: 'Sí. Tienes 1 revisión incluida en el pago inicial. Cambios adicionales o continuos se cubren con el plan de mantenimiento mensual.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-6 bg-background relative" data-id="element-20">
      <div className="max-w-3xl mx-auto" data-id="element-21">
        <div className="text-center mb-16" data-id="element-22">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-6" data-id="element-23">
            Preguntas Frecuentes
          </h2>
          <p className="text-xl text-text-secondary" data-id="element-24">
            Resolvemos tus dudas para que des el paso con confianza.
          </p>
        </div>

        <div className="space-y-4" data-id="element-25">
          {faqs.map((faq, index) => <div key={index} className={`glass-panel rounded-2xl overflow-hidden transition-all duration-300 ${openIndex === index ? 'border-primary/30 bg-white/[0.05]' : 'border-white/5'}`} data-id="element-26">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-27">
                <span className="text-lg font-medium text-white pr-8" data-id="element-28">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-text-secondary transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180 text-primary' : ''}`} data-id="element-29" />
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-30">
                <p className="text-text-secondary leading-relaxed" data-id="element-31">
                  {faq.answer}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}